"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProgressBarComponent = exports.LabelPosition = void 0;
var d3 = require("d3");
var React = require("react");
var react_1 = require("react");
var styles = require("../styles/ProgressBar");
var colors = require("../util/colors");
var sizes = require("../util/sizes");
var utils_1 = require("../util/utils");
var InfoCardComponent_1 = require("./InfoCardComponent");
var LabelPosition;
(function (LabelPosition) {
    LabelPosition[LabelPosition["UPPER"] = 0] = "UPPER";
    LabelPosition[LabelPosition["LOWER"] = 1] = "LOWER";
})(LabelPosition = exports.LabelPosition || (exports.LabelPosition = {}));
var ProgressBarComponent = function (props) {
    var value = props.value, _a = props.labels, labels = _a === void 0 ? {} : _a, _b = props.bars, bars = _b === void 0 ? {} : _b, title = props.title, tooltip = props.tooltip, showValue = props.showValue, width = props.width, _c = props.isPercent, isPercent = _c === void 0 ? false : _c;
    var _d = labels, minLabel = _d.minLabel, maxLabel = _d.maxLabel, _e = _d.position, position = _e === void 0 ? LabelPosition.LOWER : _e, _f = _d.minLabelColor, minLabelColor = _f === void 0 ? colors.tableauGray11 : _f, _g = _d.maxLabelColor, maxLabelColor = _g === void 0 ? colors.tableauGray11 : _g;
    var _h = bars.barColor, barColor = _h === void 0 ? colors.chartDefault : _h, _j = bars.backgroundColor, backgroundColor = _j === void 0 ? colors.grayBackground : _j;
    var chartRef = react_1.useRef(null);
    var barWidth = width !== null && width !== void 0 ? width : sizes.widthRegular;
    var height = 38;
    var barHeight = 20;
    var range = isPercent ? [0, 100] : [0, 1];
    var xScale = d3.scaleLinear().domain(range).rangeRound([0, barWidth]);
    var renderLabels = function () {
        return (React.createElement("div", { className: styles.progressBarLabels },
            React.createElement("label", { style: { color: minLabelColor, textAlign: 'left' } }, minLabel),
            React.createElement("label", { style: { color: maxLabelColor, textAlign: 'right' } }, maxLabel)));
    };
    var drawBar = react_1.useCallback(function (color, width) {
        d3.select(chartRef.current)
            .append('rect')
            .attr('rx', 0)
            .attr('ry', 0)
            .attr('fill', color)
            .attr('height', barHeight)
            .attr('width', width)
            .attr('x', 0);
    }, [barHeight]);
    react_1.useEffect(function () {
        d3.select(chartRef.current).selectAll('*').remove();
        var svg = d3.select(chartRef.current).attr('width', barWidth).attr('height', height);
        var axis = utils_1.getLinearAxis(xScale, utils_1.AxisPosition.Bottom);
        drawBar(backgroundColor, barWidth);
        drawBar(barColor, xScale(value) || 0);
        var tickFormat = isPercent ? utils_1.TickFormat.progressBarPercent : utils_1.TickFormat.progressBar;
        utils_1.formatAxis(axis, 5, sizes.defaultTickSize, 3, tickFormat);
        utils_1.drawAxis(svg, axis, 0, barHeight + 5);
    }, [backgroundColor, barColor, drawBar, xScale, value, barWidth, barHeight, isPercent]);
    var showedValue = showValue ? value : undefined;
    var inlineStyle = { width: barWidth };
    return (React.createElement("div", { style: inlineStyle },
        title && React.createElement(InfoCardComponent_1.InfoCardComponent, { title: title, tooltip: tooltip, value: showedValue, width: barWidth }),
        position === LabelPosition.UPPER && renderLabels(),
        React.createElement("svg", { ref: chartRef }),
        position === LabelPosition.LOWER && renderLabels()));
};
exports.ProgressBarComponent = ProgressBarComponent;
//# sourceMappingURL=ProgressBarComponent.js.map